import { Zero } from '@rocicorp/zero';
import { QueryClient } from '@tanstack/react-query';
import { createRouter as createTanstackRouter } from '@tanstack/react-router';

import type { Api } from '@/lib/clients';
import { routeTree } from '@/routeTree.gen';
import { Installation } from '@/services/org';

export interface RouterContext {
  isSignedIn: boolean;
  api: Api;
  queryClient: QueryClient;
  userId: string | null | undefined;
  getToken: (options?: {
    template?: string;
    organizationId?: string;
    leewayInSeconds?: number;
    skipCache?: boolean;
  }) => Promise<string | null>;
}

export function createRouter(queryClient: QueryClient, api: Api) {
  return createTanstackRouter({
    routeTree,
    context: {
      queryClient,
      api,
      isSignedIn: false,
      getToken: undefined!,
      userId: undefined,
    },
    defaultPreload: 'intent',
    scrollRestoration: true,
    scrollRestorationBehavior: 'smooth',
  });
}

export type Router = ReturnType<typeof createRouter>;

declare module '@tanstack/react-router' {
  interface Register {
    router: Router;
  }
}
